function ManualPaymentInstructions({ order }) {
  const snapshot = order?.payment_instructions_snapshot || {};
  const details = snapshot.payment_method_details || {};

  if (!order || order.payment_method === "stripe") {
    return null;
  }

  return (
    <section className="manual-payment-box">
      <p className="eyebrow">Payment Instructions</p>
      <h2>Complete your {order.payment_method === "cashapp" ? "Cash App" : order.payment_method} payment</h2>
      {details.recipient_name ? <p><strong>Name:</strong> {details.recipient_name}</p> : null}
      {details.recipient_email ? <p><strong>Email:</strong> {details.recipient_email}</p> : null}
      {details.recipient_phone ? <p><strong>Phone:</strong> {details.recipient_phone}</p> : null}
      {details.cashtag ? <p><strong>Cashtag:</strong> {details.cashtag}</p> : null}
      {details.instructions ? <p>{details.instructions}</p> : null}
      {snapshot.payment_notes ? <p>{snapshot.payment_notes}</p> : null}
      <p className="muted-text">Your order is saved while staff verifies payment.</p>
    </section>
  );
}

export default ManualPaymentInstructions;
